
export const strongTranslationsKO = {
  "G11": {
    m: "아브라함",
    d: "족장 아브라함, 믿는 자의 아버지.",
    u: "신약에서 73번 사용됨. 믿음의 모범.",
    e: "히브리어 אַבְרָהָם(Abraham)에서 유래 = 많은 자의 아버지"
  },
  "G25": {
    m: "신성하고 무조건적인 사랑으로 사랑하다",
    d: "이타적이고 희생적이며 신성한 사랑으로 사랑하는 것. 이것은 인류를 향한 하나님의 사랑이며, 우리가 서로에게 가져야 할 사랑입니다.",
    u: "신약에서 143번 사용됨. 신성하고 완전하며 무조건적인 사랑을 나타냅니다.",
    e: "ἄγω(ago)에서 유래 = 인도하다, 선으로 이끌다"
  },
  "G26": {
    m: "신성한 사랑, 자비",
    d: "하나님의 완전한 사랑; 형제애, 애정, 선의, 자비. 하나님과 인간, 그리고 인간과 이웃을 결속시키는 사랑.",
    u: "신약에서 116번 사용됨. 신성한 사랑을 나타내는 기독교의 핵심 단어.",
    e: "ἀγαπάω(agapao)에서 파생됨"
  },
  "G27": {
    m: "사랑받는, 소중한",
    d: "사랑받는, 소중히 여기는; 하나님이나 사람들의 사랑받는 자.",
    u: "신약에서 61번 사용됨. 하나님의 사랑받는 아들.",
    e: "ἀγαπάω(agapao)에서 유래 = 사랑하다"
  },
  "G32": {
    m: "천사, 전령",
    d: "전령; 하나님을 섬기는 천상의 천사.",
    u: "신약에서 175번 사용됨. 하나님의 천사들.",
    e: "ἀγγέλλω(aggello)에서 유래 = 선포하다"
  },
  "G36": {
    m: "미천한 출신, 천한",
    d: "고귀하지 않은, 낮은 출신; 멸시받는.",
    u: "신약에서 1번 사용됨(고린도전서 1:28).",
    e: "ἀ-(부정) + γένος(genos) = 출생"
  },
  "G93": {
    m: "불의, 사악",
    d: "법의 위반, 불의; 악, 도덕적 사악.",
    u: "신약에서 25번 사용됨. δικαιοσύνη(의)의 반대.",
    e: "ἀ-(부정) + δίκη(dike) = 정의"
  },
  "G154": {
    m: "구하다, 기도하다, 간청하다",
    d: "구하다, 무언가를 위해 기도하다, 간청하다, 청원하다. 겸손하고 정중한 요청.",
    u: "신약에서 70번 사용됨. 하나님이나 사람에게 향한 요청.",
    e: "αἰτέω(아이테오) 기본 어근에서; 구하다"
  },
  "G166": {
    m: "영원한, 영구적인",
    d: "시작도 끝도 없이 항상 존재하는; 신약에서는 종종 하나님 안의 영생과 연결됨.",
    u: "신약에서 71번 사용됨. 종종 영생과 하나님의 나라를 수식함.",
    e: "αἰών(aion)에서 유래 = 시대, 영원"
  },
  "G225": {
    m: "진리, 실재",
    d: "하나님과 인간의 의무에 관한 것에서 참된 것; 계시된 신성한 진리.",
    u: "신약에서 109번 사용됨. 예수 가르침의 핵심 개념.",
    e: "ἀληθής(alethes)에서 유래 = 참된, 진실한"
  },
  "G281": {
    m: "아멘, 진실로",
    d: "확인 공식: 그렇게 되소서, 진실로, 확실히.",
    u: "신약에서 129번 사용됨. 예수는 '진실로 진실로'라고 말씀하심.",
    e: "히브리어 אָמֵן(amen)에서 유래 = 견고한, 신실한"
  },
  "G444": {
    m: "사람, 인간",
    d: "인간, 남자나 여자; 일반적으로 인류.",
    u: "신약에서 550번 사용됨. 하나님의 형상대로 지음 받은 인간.",
    e: "ἀνήρ(aner) = 남자 + ὤψ(ops) = 얼굴"
  },
  "G622": {
    m: "잃다, 멸망시키다, 멸망하다",
    d: "완전히 파괴하다; 잃다, 멸망하다; 망하다.",
    u: "신약에서 90번 사용됨. 잃어버린 것을 구원하다.",
    e: "ἀπό(apo) = ~로부터 + ὄλλυμι(ollumi) = 파괴하다"
  },
  "G649": {
    m: "보내다, 파견하다",
    d: "사명을 가지고 보내다; 대사로 파견하다.",
    u: "신약에서 132번 사용됨. 성부가 성자를 보내신다.",
    e: "ἀπό(apo) = ~로부터 + στέλλω(stello) = 보내다"
  },
  "G721": {
    m: "어린양",
    d: "작은 어린양; 하나님의 어린양으로서 예수 그리스도를 나타냄.",
    u: "신약에서 30번 사용됨, 특히 요한계시록에서.",
    e: "ἀρήν(aren) = 어린양의 지소사"
  },
  "G730": {
    m: "남성, 남자",
    d: "남성의, 수컷.",
    u: "신약에서 9번 사용됨. 하나님이 사람을 남자와 여자로 창조하셨다.",
    e: "기본 어근"
  },
  "G740": {
    m: "떡",
    d: "떡, 음식; 생명의 떡 = 그리스도.",
    u: "신약에서 97번 사용됨. 생명의 떡 예수.",
    e: "ἄρω(aro)에서 유래 = 들다, 올리다"
  },
  "G746": {
    m: "시작, 근원",
    d: "시작, 기원, 첫 번째 원리. 요한복음 1:1-2에서는 말씀(로고스)이 이미 존재했던 영원한 시작을 가리킨다.",
    u: "신약에서 55번 사용됨. 요한복음 1:1의 핵심 단어 '태초에 말씀이 계셨다'.",
    e: "일차적인 단어; 시작, 첫 번째 기원"
  },
  "G772": {
    m: "약한, 병든",
    d: "힘이 없는, 약한; 병든, 허약한; 영적으로 약한.",
    u: "신약에서 25번 사용됨. 하나님은 세상의 약한 것들을 택하신다.",
    e: "ἀ-(부정) + σθένος(sthenos) = 힘"
  },
  "G907": {
    m: "침례를 주다, 담그다",
    d: "물에 담그다; 정화하거나 입문시키기 위해 침례를 주다.",
    u: "신약에서 77번 사용됨. 기독교의 침례.",
    e: "βάπτω(bapto)에서 유래 = 담그다, 담가넣다"
  },
  "G1080": {
    m: "낳다, 태어나게 하다",
    d: "낳다, 출산하다; 영적으로 다시 태어나다.",
    u: "신약에서 97번 사용됨. 하나님에게서 나다, 거듭나다.",
    e: "기본 어근"
  },
  "G1096": {
    m: "되다, 일어나다, 생기다",
    d: "되다, 존재하게 되다, 일어나다, 발생하다, 생기다.",
    u: "신약에서 678번 사용됨. '만물이 그로 말미암아 지은 바 되었다' (요한 1:3).",
    e: "γίνομαι(ginomai)에서 유래 = 되다"
  },
  "G1097": {
    m: "알다, 이해하다",
    d: "개인적 경험으로 알다; 이해하다, 인식하다, 의식하다.",
    u: "신약에서 222번 사용됨. 단순히 지적인 것이 아닌 경험적 지식.",
    e: "인도유럽어 어근 *gen-에서 = 낳다, 알다"
  },
  "G1100": {
    m: "혀, 언어",
    d: "말하는 기관; 언어, 방언; 방언의 은사.",
    u: "신약에서 50번 사용됨. 방언의 은사.",
    e: "기본 어근"
  },
  "G1166": {
    m: "보여주다, 입증하다",
    d: "눈에 드러내다, 보여주다; 증명하다, 입증하다.",
    u: "신약에서 33번 사용됨. 하나님은 그분의 영광을 보여주신다.",
    e: "기본 어근"
  },
  "G1208": {
    m: "둘째의, 두 번째",
    d: "연속이나 순서에서 두 번째.",
    u: "신약에서 44번 사용됨. 둘째 계명.",
    e: "δύο(duo) = 둘"
  },
  "G1271": {
    m: "지성, 사고",
    d: "생각하고 듣고 이해하는 능력; 정신, 이해력.",
    u: "신약에서 12번 사용됨. 그리스도로 인해 새롭게 된 정신.",
    e: "διά(dia) = 통해 + νοῦς(nous) = 정신"
  },
  "G1320": {
    m: "선생, 스승, 교사",
    d: "선생, 교사; 종교적 진리를 가르치는 자.",
    u: "신약에서 59번 사용됨. '랍비여, 당신이 하나님께로부터 오신 선생인 줄 우리가 아나이다' (요한 3:2).",
    e: "διδάσκω(didasko)에서 유래 = 가르치다"
  },
  "G1325": {
    m: "주다, 수여하다",
    d: "누군가에게 무언가를 주다; 수여하다, 허락하다; 넘기다.",
    u: "신약에서 415번 사용됨. 하나님은 관대하게 주신다.",
    e: "기본 어근"
  },
  "G1372": {
    m: "목마르다, 간절히 원하다",
    d: "갈증으로 고통받다; 간절히 원하다, 열망하다.",
    u: "신약에서 16번 사용됨. 하나님을 향한 영적 갈증.",
    e: "δίψα(dipsa) = 갈증"
  },
  "G1401": {
    m: "종, 하인",
    d: "노예, 하인; 자원하는 하나님의 종.",
    u: "신약에서 124번 사용됨. 그리스도의 종들.",
    e: "δέω(deo)에서 유래 = 묶다"
  },
  "G1411": {
    m: "능력, 힘, 기적",
    d: "힘, 능력, 역량; 능력의 행위, 기적.",
    u: "신약에서 120번 사용됨. 하나님과 성령의 능력.",
    e: "δύναμαι(dunamai)에서 유래 = 할 수 있다"
  },
  "G1417": {
    m: "둘",
    d: "숫자 둘; 한 쌍.",
    u: "신약에서 135번 사용됨. 두세 증인.",
    e: "기본 어근"
  },
  "G1473": {
    m: "나, 나를",
    d: "1인칭 단수 인칭 대명사.",
    u: "신약에서 2567번 사용됨. 매우 빈번함.",
    e: "기본 대명사"
  },
  "G1484": {
    m: "민족, 백성, 이방인",
    d: "백성, 민족; 이방 민족들(비유대인).",
    u: "신약에서 162번 사용됨. 모든 민족을 위한 복음.",
    e: "기본 어근"
  },
  "G1492": {
    m: "알다, 보다, 이해하다",
    d: "지각을 통해 알다, 보다, 이해하다, 깨닫다. 경험이나 계시를 통해 얻은 지식.",
    u: "신약에서 666번 사용됨. 요한복음에서 지식의 기본 동사.",
    e: "εἴδω(에이도)의 완료형; 보다, 알다"
  },
  "G1510": {
    m: "있다, 존재하다",
    d: "모든 의미에서 존재 동사; 존재하다, 머물다, 일어나다.",
    u: "신약에서 가장 많이 사용된 동사(2460번 이상).",
    e: "기본 어근"
  },
  "G1515": {
    m: "평화",
    d: "평온한 상태; 하나님과의 평화; 사람들 사이의 조화.",
    u: "신약에서 92번 사용됨. 그리스도의 평화.",
    e: "εἴρω(eiro)에서 유래 = 결합하다, 묶다"
  },
  "G1520": {
    m: "하나, 유일한",
    d: "단 하나; 유일한, 오직; 어떤.",
    u: "신약에서 344번 사용됨. 하나님의 단일성, 연합된 교회.",
    e: "기본 어근"
  },
  "G1586": {
    m: "선택하다, 택하다",
    d: "자신을 위해 선택하다, 선발하다; 신성한 은혜로 택하다.",
    u: "신약에서 21번 사용됨. 하나님이 그분의 자녀들을 택하신다.",
    e: "ἐκ(ek) = 밖으로 + λέγω(lego) = 선택하다"
  },
  "G1658": {
    m: "자유로운, 해방된",
    d: "자유로운, 노예가 아닌; 죄의 노예됨에서 해방된.",
    u: "신약에서 23번 사용됨. 그리스도 안에서 자유로워진.",
    e: "아마도 ἔρχομαι(erchomai) = 오다"
  },
  "G1672": {
    m: "헬라인, 이방인",
    d: "출생이나 언어로 헬라인; 비유대인.",
    u: "신약에서 25번 사용됨. 그리스도 안에서는 유대인이나 헬라인이 없음.",
    e: "Ἑλλάς(Hellas) = 헬라"
  },
  "G1680": {
    m: "소망, 확신 있는 기대",
    d: "좋은 것들에 대한 기대, 하나님께 근거한 희망; 신성한 약속에 기초한 미래에 대한 확신.",
    u: "신약에서 54번 사용됨. 믿음, 소망, 사랑이라는 세 가지 신학적 덕목 중 하나.",
    e: "ἔλπω(elpo)에서 유래 = 기다리다, 희망하다"
  },
  "G1743": {
    m: "강하게 하다, 강하게 만들다",
    d: "강하게 만들다, 강화하다; 능력을 주다.",
    u: "신약에서 8번 사용됨. 하나님이 신자들을 강하게 하신다.",
    e: "ἐν(en) = 안에 + δυναμόω(dynamoo) = 강하게 하다"
  },
  "G1746": {
    m: "입다, 옷을 입다",
    d: "옷을 입다; 특성이나 능력을 입다.",
    u: "신약에서 27번 사용됨. 그리스도를 입다, 하나님의 전신갑주를 입다.",
    e: "ἐν(en) = 안에 + δύω(duo) = 들어가다, 입다"
  },
  "G1785": {
    m: "계명, 명령",
    d: "명령, 계명, 규율; 특히 신성한 계명.",
    u: "신약에서 67번 사용됨. 하나님과 그리스도의 계명들.",
    e: "ἐντέλλομαι(entellomai)에서 유래 = 명령하다"
  },
  "G1848": {
    m: "멸시하다, 경멸하다",
    d: "무로 여기다, 멸시하다; 경멸로 대하다.",
    u: "신약에서 11번 사용됨. 세상은 하나님이 선택하신 것을 멸시한다.",
    e: "ἐξ(ex) = 밖으로 + οὐθείς(outheis) = 아무도"
  },
  "G2041": {
    m: "일, 노동, 행위",
    d: "일, 노동; 행동, 행위; 성취된 일.",
    u: "신약에서 169번 사용됨. 하나님의 일들, 선한 행실.",
    e: "ἔργω(ergo)에서 유래 = 일하다"
  },
  "G2048": {
    m: "광야, 황량한",
    d: "황량한 곳, 광야; 고독한, 인구가 없는.",
    u: "신약에서 48번 사용됨. 광야에서의 예수의 40일.",
    e: "ἔρημος(eremos) = 버려진"
  },
  "G2065": {
    m: "묻다, 질문하다, 문의하다",
    d: "묻다, 질문하다, 정보를 얻기 위해 문의하다. 조사나 탐구.",
    u: "신약에서 63번 사용됨. 답을 얻기 위한 질문.",
    e: "불확실한 어근; 묻다, 질문하다"
  },
  "G2189": {
    m: "원수됨, 적대감",
    d: "증오, 적대감, 원수됨.",
    u: "신약에서 6번 사용됨. 하나님과의 원수됨이 없어짐.",
    e: "ἐχθρός(echthros) = 원수"
  },
  "G2205": {
    m: "열심, 질투, 시기",
    d: "열정적인 열의; 긍정적일 수도(하나님을 향한 열심) 부정적일 수도(질투, 시기) 있음.",
    u: "신약에서 16번 사용됨. 문맥에 따라 미덕이거나 악덕일 수 있음.",
    e: "ζέω(zeo)에서 유래 = 끓다, 뜨겁다"
  },
  "G2222": {
    m: "생명",
    d: "육체적 또는 영적 생명; 하나님 안의 영원한 생명.",
    u: "신약에서 135번 사용됨. 예수는 생명이시다.",
    e: "ζάω(zao)에서 유래 = 살다"
  },
  "G2258": {
    m: "있었다, 그는 있었다",
    d: "있었다, 그는 있었다, 그녀는 있었다. 동사 있다(εἰμί)의 미완료형. 과거의 상태나 존재를 표현한다.",
    u: "신약에서 267번 사용됨. 요한복음 1:1 '태초에 말씀이 계시니라'에서 중요.",
    e: "εἰμί(에이미)의 미완료형 = 있다; 있었다"
  },
  "G2296": {
    m: "놀라다, 경탄하다, 감탄하다",
    d: "놀라다, 경탄하다, 놀라워하다, 감탄하다. 특별한 것에 대한 놀라움의 반응.",
    u: "신약에서 43번 사용됨. 예수의 기적과 가르침에 대한 빈번한 반응.",
    e: "θαῦμα(타우마) = 놀라운 일에서; 놀라다"
  },
  "G2316": {
    m: "하나님, 신성",
    d: "유일한 참 하나님, 지극히 높고 영원하신 분. 신약에서 성부 하나님, 또는 예수 그리스도 아들, 또는 성령을 가리킴 - 거룩한 삼위일체.",
    u: "신약에서 1343번 사용됨. 삼위일체의 연합 안에서 유일한 참 하나님을 나타내는 기본 단어.",
    e: "스트롱에 따르면 불확실한 어원. 신격, 특히 최고 신성을 가리킴. 성경적 용법: 구원 역사에서 역사하시는 살아계신 하나님을 계시함."
  },
  "G2338": {
    m: "여성, 여자",
    d: "여성의, 암컷.",
    u: "신약에서 5번 사용됨. 그리스도 안에서 남자와 여자가 평등함.",
    e: "θηλάζω(thelazo)에서 유래 = 젖을 먹이다"
  },
  "G2362": {
    m: "보좌",
    d: "왕좌, 보좌; 왕의 권능과 권위.",
    u: "신약에서 62번 사용됨. 하나님과 어린양의 보좌.",
    e: "기본 어근"
  },
  "G2381": {
    m: "도마",
    d: "도마, 고유명사. 열두 사도 중 하나, 디두모(쌍둥이)라고도 불림. 부활의 증거를 요구한 것으로 유명.",
    u: "신약에서 11번 사용됨. 의심했다가 믿은 사도.",
    e: "아람어 תְּאוֹמָא(테오마)에서 = 쌍둥이"
  },
  "G2398": {
    m: "자신의, 특별한, 개인적인",
    d: "자신의, 특별한, 개인적인, 사적인. 누군가에게 특별히 속하는 것, 다른 것들과 구별되는.",
    u: "신약에서 114번 사용됨. 개인적 소유와 구별의 개념.",
    e: "불확실한 어근에서; 자신의, 특별한"
  },
  "G2424": {
    m: "예수",
    d: "나사렛 예수, 메시아, 구주.",
    u: "신약에서 917번 사용됨. 모든 이름 위에 뛰어난 이름.",
    e: "히브리어 יְהוֹשֻׁעַ(Yehoshua)에서 유래 = 여호와는 구원하신다"
  },
  "G2453": {
    m: "유대인, 유대 사람",
    d: "유대 민족에 속한; 유대 지방의 거주자.",
    u: "신약에서 195번 사용됨. 하나님의 택하신 백성인 유대인들.",
    e: "Ἰούδας(Ioudas) = 유다"
  },
  "G2491": {
    m: "요한",
    d: "요한, 고유명사. 선구자 세례 요한, 사랑받는 사도 요한, 복음서와 서신의 저자.",
    u: "신약에서 135번 사용됨. 신약의 두 위대한 인물의 이름.",
    e: "히브리어 יוֹחָנָן(요하난)에서 = 여호와는 은혜로우시다"
  },
  "G2531": {
    m: "같이, ~에 따라",
    d: "같이, 같은 방식으로; ~에 따라, ~만큼.",
    u: "신약에서 182번 사용됨. 비교 접속사.",
    e: "κατά(kata) = ~에 따라 + ὡς(hos) = 같이"
  },
  "G2537": {
    m: "새로운, 최근의",
    d: "시간이나 특성에서 새로운; 신선한, 최근의, 사용되지 않은.",
    u: "신약에서 42번 사용됨. 새 창조, 새 계명.",
    e: "어근 불확실"
  },
  "G2570": {
    m: "선한, 아름다운",
    d: "본질적으로 선한, 아름다운; 명예로운, 탁월한, 덕스러운.",
    u: "신약에서 100번 사용됨. 선한 목자, 선한 행실.",
    e: "기본 어근"
  },
  "G2588": {
    m: "마음",
    d: "육체적 심장; 내면 생활의 중심, 영혼, 정신; 생각과 감정.",
    u: "신약에서 156번 사용됨. 영적 생활의 자리.",
    e: "기본 어근"
  },
  "G2596": {
    m: "~에 따라, ~에 반하여, ~를 통해",
    d: "여러 의미를 가진 전치사: ~에 따라, ~에 일치하여; ~에 반하여; ~를 통해.",
    u: "신약에서 470번 이상 사용됨. 매우 빈번한 전치사.",
    e: "기본 전치사"
  },
  "G2617": {
    m: "부끄럽게 하다, 불명예스럽게 하다",
    d: "부끄럽게 하다, 불명예스럽게 하다; 혼란시키다, 굴욕시키다.",
    u: "신약에서 13번 사용됨. 하나님은 세상의 지혜로운 자들을 혼란시키신다.",
    e: "κατά(kata) = ~에 대하여 + αἰσχύνω(aischuno) = 부끄러워하다"
  },
  "G2744": {
    m: "자랑하다, 뽐내다",
    d: "자랑하다, 뽐내다; 무언가에 대한 자부심을 찾다.",
    u: "신약에서 37번 사용됨. 주 안에서 자랑하다.",
    e: "καῦχος(kauchos) = 자랑"
  },
  "G2889": {
    m: "세상, 우주, 인류",
    d: "세계의 질서, 우주; 타락한 인류; 하나님을 대적하는 체제.",
    u: "신약에서 186번 사용됨. 창조물이나 죄악된 체제를 나타낼 수 있음.",
    e: "κοσμέω(kosmeo)에서 유래 = 장식하다, 정돈하다"
  },
  "G2919": {
    m: "심판하다, 결정하다",
    d: "심판하다, 판결을 내리다; 결정하다, 확정하다.",
    u: "신약에서 114번 사용됨. 하나님이 세상을 심판하신다.",
    e: "기본 어근"
  },
  "G2920": {
    m: "심판, 의, 정죄",
    d: "심판, 의, 정죄, 사법적 결정. 하나님의 심판, 의롭고 완전함.",
    u: "신약에서 47번 사용됨. 신적 의의 중심 개념.",
    e: "κρίνω(크리노)에서 = 심판하다, 결정하다"
  },
  "G2962": {
    m: "주, 주인, 소유자",
    d: "주, 주인; 존경과 신적 권위의 칭호; 예수를 주로.",
    u: "신약에서 748번 사용됨. '도마가 이르되 주여 주께서 어디로 가시는지 우리가 알지 못하거늘' (요한 14:5).",
    e: "κύριος(kurios)에서 유래 = 권위를 가지다"
  },
  "G2992": {
    m: "백성",
    d: "백성, 민족; 특히 하나님의 백성(이스라엘이나 교회).",
    u: "신약에서 142번 사용됨. 하나님의 택하신 백성.",
    e: "기본 어근"
  },
  "G3022": {
    m: "흰, 빛나는",
    d: "흰, 찬란한; 순결과 승리의 상징.",
    u: "신약에서 25번 사용됨. 구속받은 자들의 흰 옷.",
    e: "λευκός(leukos) = 흰, 빛나는"
  },
  "G3056": {
    m: "말씀, 단어, 이성",
    d: "발화된 말; 이성, 지성; 로고스 = 그리스도.",
    u: "신약에서 330번 사용됨. 성육신하신 로고스.",
    e: "λέγω(lego)에서 유래 = 말하다"
  },
  "G3101": {
    m: "제자, 학생",
    d: "배우는 자, 학생, 제자; 예수의 추종자.",
    u: "신약에서 261번 사용됨. 그리스도의 추종자들을 나타냄.",
    e: "μανθάνω(manthano)에서 유래 = 배우다"
  },
  "G3141": {
    m: "증거, 증언",
    d: "증거, 증언, 입증, 증명. 진리에 대한 증거, 특히 그리스도에 대한 증거.",
    u: "신약에서 37번 사용됨. 요한복음의 주요 주제.",
    e: "μάρτυς(마르투스)에서 = 증인"
  },
  "G3173": {
    m: "큰, 중요한",
    d: "크기, 양 또는 중요성에서 큰; 강력한, 놀라운.",
    u: "신약에서 243번 사용됨. 하나님의 위대하심.",
    e: "기본 어근"
  },
  "G3320": {
    m: "막힌 담",
    d: "중간 벽, 구분하는 담.",
    u: "신약에서 1번 사용됨(에베소서 2:14). 유대인과 이방인 사이의 벽.",
    e: "μέσος(mesos) = 중간 + τοῖχος(toichos) = 벽"
  },
  "G3439": {
    m: "독생하신, 유일하신",
    d: "종류에서 유일한, 유일하게 낳으신; 독생자.",
    u: "신약에서 9번 사용됨. 하나님의 독생자.",
    e: "μόνος(monos) = 혼자 + γίνομαι(ginomai) = 되다"
  },
  "G3474": {
    m: "어리석음, 우둔함",
    d: "어리석음, 불합리함; 지혜가 결여된 것.",
    u: "신약에서 5번 사용됨. 하나님의 지혜는 세상에 어리석음으로 보인다.",
    e: "μωρός(moros)에서 유래 = 어리석은, 무감각한"
  },
  "G3475": {
    m: "모세",
    d: "모세, 이스라엘의 율법 수여자.",
    u: "신약에서 80번 사용됨. 모세의 율법.",
    e: "히브리어 מֹשֶׁה(Mosheh)에서 유래 = 건져 올린(물에서)"
  },
  "G3530": {
    m: "니고데모",
    d: "니고데모, 고유명사. 밤에 예수께 온 바리새인이자 유대인 지도자. '백성의 승리'를 의미하는 그리스어 이름.",
    u: "신약에서 5번 사용됨. 요한복음의 중요한 인물.",
    e: "그리스어 νίκη(니케) = 승리와 δῆμος(데모스) = 백성에서"
  },
  "G3551": {
    m: "율법, 토라",
    d: "율법, 토라, 규칙, 원리. 모세의 율법, 신적 율법, 하나님의 계명.",
    u: "신약에서 194번 사용됨. 신적 계시의 중심 개념.",
    e: "νέμω(네모)에서 = 나누다, 주다; 주어진 율법"
  },
  "G3571": {
    m: "밤",
    d: "밤, 해가 지고 뜨는 사이의 어둠의 시간. 종종 영적 무지에 대한 은유.",
    u: "신약에서 61번 사용됨. 요한의 상징체계에서 빛과 대조됨.",
    e: "기본 여성 명사; 밤"
  },
  "G3598": {
    m: "길, 방법",
    d: "도로, 길; 삶의 방식, 행동; 구원의 길.",
    u: "신약에서 101번 사용됨. 예수는 길이시다.",
    e: "기본 어근"
  },
  "G3609": {
    m: "가정의, 집의",
    d: "집에 속한, 가족 구성원; 가정 하인.",
    u: "신약에서 3번 사용됨. 하나님의 가족 구성원을 묘사함.",
    e: "οἶκος(oikos) = 집"
  },
  "G3664": {
    m: "비슷한, 같은",
    d: "비슷한, 같은 본질이나 성격; 동등한.",
    u: "신약에서 45번 사용됨. 첫째와 같은 둘째 계명.",
    e: "ὁμός(homos) = 같은"
  },
  "G3686": {
    m: "이름",
    d: "이름, 칭호; 명성; 권위, 능력.",
    u: "신약에서 228번 사용됨. 예수의 이름.",
    e: "기본 어근"
  },
  "G3708": {
    m: "보다, 바라보다",
    d: "눈으로 보다; 인식하다, 이해하다; 나타나다.",
    u: "신약에서 454번 사용됨. 그리스도를 보다, 아버지를 보다.",
    e: "기본 어근"
  },
  "G3735": {
    m: "산, 언덕",
    d: "산, 높은 산; 높은 언덕.",
    u: "신약에서 63번 사용됨. 변화산.",
    e: "아마도 ὁράω(horao) = 보다"
  },
  "G3756": {
    m: "~아니다, 아니오",
    d: "절대적 부정, 아니오, 아니다.",
    u: "신약에서 1600번 이상 사용됨. 매우 빈번한 부정 불변화사.",
    e: "기본 부정 불변화사"
  },
  "G3762": {
    m: "아무도, 아무것도, 아무",
    d: "아무도, 아무것도, 아무, 하나도. 존재나 수량의 절대적 부정.",
    u: "신약에서 234번 사용됨. 매우 일반적인 강한 부정.",
    e: "οὐδέ(우데)와 εἷς(헤이스)에서; 하나도"
  },
  "G3778": {
    m: "이, 이것, 이들",
    d: "지시대명사: 이, 이것, 이들. 가까이 있거나 이전에 언급된 것을 가리킨다.",
    u: "신약에서 1388번 사용됨. 가장 빈번한 지시대명사.",
    e: "일차적 지시대명사"
  },
  "G3789": {
    m: "뱀",
    d: "뱀, 파충류; 옛 뱀(사탄).",
    u: "신약에서 14번 사용됨. 광야의 놋뱀.",
    e: "기본 어근"
  },
  "G3793": {
    m: "군중, 무리",
    d: "사람들의 군중, 무리; 대중.",
    u: "신약에서 175번 사용됨. 예수를 따랐던 군중들.",
    e: "ὄχος(ochos) = 탈것(운반하는)"
  },
  "G3880": {
    m: "받다, 취하다, 받아들이다",
    d: "받다, 취하다, 받아들이다, 붙잡다. 제공되거나 주어진 것을 받아들이다.",
    u: "신약에서 59번 사용됨. 복음을 받아들이는 중심 개념.",
    e: "παρά(파라) = 옆에서와 λαμβάνω(람바노) = 취하다에서"
  },
  "G3956": {
    m: "모든, 각각의",
    d: "모든, 각각의, 모두; 전체, 총체.",
    u: "신약에서 1244번 사용됨. 가장 빈번한 단어 중 하나.",
    e: "기본 어근"
  },
  "G3962": {
    m: "아버지",
    d: "육체적 또는 영적 아버지; 조상; 성부 하나님.",
    u: "신약에서 413번 사용됨. 종종 하나님을 나타내는 데 사용됨.",
    e: "라틴어 'pater'와 관련된 기본 어근"
  },
  "G4100": {
    m: "믿다, 신앙을 갖다",
    d: "~을 믿다, 믿음을 갖다; ~을 신뢰하다, ~에 의지하다.",
    u: "신약에서 241번 사용됨. 구원받기 위해 예수를 믿다.",
    e: "πίστις(pistis) = 믿음"
  },
  "G4102": {
    m: "믿음, 신뢰, 충실함",
    d: "어떤 것의 진리에 대한 확신, 믿음; 신약에서는 하나님과 신성한 것들에 관한 인간의 관계에 대한 확신.",
    u: "신약에서 244번 사용됨. 기독교 신앙의 핵심 개념.",
    e: "πείθω(peitho)에서 유래 = 설득하다, 확신시키다"
  },
  "G4138": {
    m: "충만, 풍성함, 채우는 것",
    d: "충만, 풍성함, 완전히 채우는 것. 전체성, 신적 완전함.",
    u: "신약에서 17번 사용됨. 그리스도 안에서의 신적 충만의 신학적 개념.",
    e: "πλήρης(플레레스) = 가득한에서; 충만"
  },
  "G4139": {
    m: "이웃, 이웃 사람",
    d: "가까운 자, 이웃; 일반적으로 이웃 사람.",
    u: "신약에서 17번 사용됨. '네 이웃을 네 자신처럼 사랑하라'.",
    e: "πλησίος(plesios) = 가까이에서 부사가 명사가 됨"
  },
  "G4151": {
    m: "영, 숨, 바람",
    d: "생명의 숨결, 생명 원리; 이성적 영혼; 성령.",
    u: "신약에서 385번 사용됨. 성령, 인간의 영 또는 영들을 나타냄.",
    e: "πνέω(pneo)에서 유래 = 불다, 숨쉬다"
  },
  "G4160": {
    m: "하다, 만들다, 성취하다",
    d: "하다, 만들다, 생산하다, 행동하다, 창조하다. 모든 종류의 활동을 포괄하는 일반적인 행동 동사.",
    u: "신약에서 568번 사용됨. 기본적인 행동 동사, 하나님의 일에서 자주 사용됨.",
    e: "일차적 동사; 하다, 성취하다"
  },
  "G4166": {
    m: "목자, 목사",
    d: "양을 지키는 자; 영적 지도자, 교회 목사.",
    u: "신약에서 18번 사용됨. 선한 목자 예수.",
    e: "ποίμνη(poimne) = 양떼"
  },
  "G4183": {
    m: "많은, 많이, 큰",
    d: "많은, 많이, 양이나 수에서 큰. 무리, 많은 양.",
    u: "신약에서 416번 사용됨. 매우 빈번한 수량 형용사.",
    e: "불확실한 어근; 많은, 많이"
  },
  "G4198": {
    m: "가다, 걷다, 여행하다",
    d: "가다, 걷다, 여행하다, 움직이다. 한 곳에서 다른 곳으로의 움직임, 종종 목적을 가지고.",
    u: "신약에서 154번 사용됨. 복음서 이야기의 기본적인 움직임 동사.",
    e: "기본 동사; 가다, 걷다"
  },
  "G4238": {
    m: "하다, 실천하다, 성취하다",
    d: "하다, 실천하다, 성취하다, 행동하다. 행동을 수행하다, 종종 반복이나 습관의 개념과 함께.",
    u: "신약에서 39번 사용됨. 종종 선과 악의 실천과 연결됨.",
    e: "πράω(프라오)의 강화형; 하다, 실천하다"
  },
  "G4263": {
    m: "양, 양떼",
    d: "암양이나 수양; 은유적으로 그리스도의 제자들.",
    u: "신약에서 39번 사용됨. 목자의 양으로서의 신자들.",
    e: "아마도 προβαίνω(probaino) = 앞으로 나아가다와 관련됨"
  },
  "G4413": {
    m: "첫째의, 주요한",
    d: "시간, 장소, 순서 또는 중요성에서 첫째.",
    u: "신약에서 155번 사용됨. 첫째 계명, 첫째 자리.",
    e: "πρό(pro) = 앞에의 최상급"
  },
  "G4561": {
    m: "육체, 몸",
    d: "고기, 살; 인간의 몸; 타락한 인간 본성.",
    u: "신약에서 147번 사용됨. 육체와 영의 대조.",
    e: "기본 어근"
  },
  "G4592": {
    m: "표적, 기적, 이적",
    d: "표적, 기적, 이적; 신적 능력을 나타내는 초자연적 현상.",
    u: "신약에서 77번 사용됨. '아무도 당신이 행하시는 이 표적들을 행할 수 없음이니이다' (요한 3:2).",
    e: "σημεῖον(semeion)에서 유래 = 표시, 기호"
  },
  "G4648": {
    m: "주의깊게 보다, 목표로 하다",
    d: "눈을 고정하다, 주의깊게 생각하다; 목표를 보다, 목적을 향하다.",
    u: "신약에서 6번 사용됨. 그리스도께 눈을 고정하라는 부름.",
    e: "σκοπός(skopos) = 목표, 목적과 관련됨"
  },
  "G4680": {
    m: "지혜로운, 학식있는",
    d: "지혜로운, 총명한, 능숙한; 교육받은, 가르침받은.",
    u: "신약에서 22번 사용됨. 진정한 지혜는 하나님에게서 온다.",
    e: "기본 어근"
  },
  "G4982": {
    m: "구원하다, 건지다",
    d: "위험이나 파멸에서 구하다; 죄에서 건지다.",
    u: "신약에서 106번 사용됨. 예수는 죄인을 구원하신다.",
    e: "σῶς(sos) = 안전한"
  },
  "G5040": {
    m: "어린 아이",
    d: "어린 아이, 유아; 제자를 위한 애정 어린 표현.",
    u: "신약에서 8번 사용됨. 요한이 독자들을 '어린 아이들'이라 부름.",
    e: "τέκνον(teknon) = 아이의 지소사"
  },
  "G5087": {
    m: "놓다, 두다, 세우다",
    d: "놓다, 두다; 세우다, 임명하다; 내려놓다, 두다.",
    u: "신약에서 100번 사용됨. 양을 위해 생명을 내려놓다.",
    e: "기본 어근"
  },
  "G5109": {
    m: "벽",
    d: "분리의 벽, 벽면.",
    u: "신약에서 1번 사용됨(사도행전 23:3).",
    e: "기본 어근"
  },
  "G5207": {
    m: "아들",
    d: "남성 후손; 제자; 집단의 구성원. 하나님의 아들 = 예수 그리스도.",
    u: "신약에서 377번 사용됨. 종종 하나님의 아들로서 예수를 나타내는 데 사용됨.",
    e: "기원 불확실, 아마도 ὕω(huo) = 비가 내리다, 낳다"
  },
  "G5281": {
    m: "인내, 견딤, 끈기",
    d: "상황이나 압박에 굴하지 않는 자의 특성; 인내하는 지구력, 항상성.",
    u: "신약에서 32번 사용됨. 필수적인 기독교 덕목.",
    e: "ὑπό(hupo) = 아래 + μένω(meno) = 머물다"
  },
  "G5312": {
    m: "높이다, 찬양하다",
    d: "높이 들어 올리다, 높이다; 찬양하다, 존귀케 하다.",
    u: "신약에서 20번 사용됨. 들리신 인자.",
    e: "ὕψος(hupsos) = 높이"
  },
  "G5376": {
    m: "빌립",
    d: "빌립, 고유명사. 열두 사도 중 하나. '말을 사랑하는 자'라는 뜻의 그리스 이름.",
    u: "신약에서 36번 사용됨. 사도와 집사의 이름.",
    e: "그리스어 φίλος(필로스) = 친구와 ἵππος(히포스) = 말에서"
  },
  "G5432": {
    m: "지키다, 보호하다",
    d: "군대 경비로 지키다; 보호하다, 보존하다.",
    u: "신약에서 4번 사용됨. 하나님의 평화가 우리 마음을 지킨다.",
    e: "φρουρός(phrouros) = 경비, 파수꾼"
  },
  "G5443": {
    m: "지파, 족속",
    d: "지파, 씨족; 공통 조상에서 내려온 백성.",
    u: "신약에서 31번 사용됨. 이스라엘의 열두 지파.",
    e: "φύω(phuo)에서 유래 = 생산하다, 자라게 하다"
  },
  "G5457": {
    m: "빛",
    d: "물리적 또는 영적 빛; 계시된 신성한 진리.",
    u: "신약에서 73번 사용됨. 세상의 빛 예수.",
    e: "φάω(phao)에서 유래 = 빛나다"
  },
  "G5463": {
    m: "기뻐하다, 즐거워하다",
    d: "기뻐하다, 행복하다; 인사 '기뻐하라' 또는 '안녕'.",
    u: "신약에서 74번 사용됨. 그리스도 안에서 기뻐하라는 빈번한 명령.",
    e: "χάρις(charis) = 은혜와 관련됨"
  },
  "G5495": {
    m: "손",
    d: "손; 능력, 권위; 행동, 일.",
    u: "신약에서 177번 사용됨. 하나님의 손, 예수의 손들.",
    e: "기본 어근"
  },
  "G5544": {
    m: "선함, 인자함",
    d: "행동으로 나타나는 선함, 실천적인 인자함; 타인에게 유익하고 도움이 되는 자의 특성.",
    u: "신약에서 10번 사용됨. 갈라디아서 5:22의 성령의 열매.",
    e: "χρηστός(chrestos)에서 유래 = 선한, 유익한, 인자한"
  },
  "G5547": {
    m: "그리스도, 메시아, 기름 부음 받은 자",
    d: "기름 부음 받은 자, 메시아; 약속된 구주로서 예수의 칭호.",
    u: "신약에서 529번 사용됨. 예수는 그리스도이시다.",
    e: "χρίω(chrio)에서 유래 = 기름 붓다"
  },
  "G5590": {
    m: "영혼, 생명",
    d: "생명의 숨결, 생명 영혼; 생명 자체; 불멸의 영혼.",
    u: "신약에서 105번 사용됨. 영적이고 영원한 생명.",
    e: "ψύχω(psucho)에서 유래 = 숨쉬다, 상쾌하게 하다"
  },
  "H120": {
    m: "사람, 인류, 아담",
    d: "사람, 인간; 인류; 첫 사람 아담.",
    u: "구약에서 562번 사용됨. 하나님이 사람을 창조하셨다.",
    e: "אָדֹם(adom) = 붉은, 또는 אֲדָמָה(adamah) = 땅"
  },
  "H160": {
    m: "사랑, 애정",
    d: "사랑, 애정; 사랑의 행위.",
    u: "구약에서 40번 사용됨. 그분의 백성을 향한 하나님의 사랑.",
    e: "אָהַב(ahab) = 사랑하다"
  },
  "H216": {
    m: "빛",
    d: "자연적 또는 영적 빛; 행복, 번영.",
    u: "구약에서 120번 사용됨. '빛이 있으라 !'",
    e: "אוֹר(or) = 빛나다"
  },
  "H430": {
    m: "하나님, 신들",
    d: "지극히 높으신 하나님(엘로힘); 때로는 재판관이나 이방 신들을 위해 사용됨.",
    u: "구약에서 2606번 사용됨. 하나님을 위한 존칭의 복수형 명칭.",
    e: "אֱלוֹהַּ(eloah) = 신의 복수형"
  },
  "H559": {
    m: "말하다, 이르다",
    d: "말하다, 이르다, 선언하다; 명령하다, 생각하다.",
    u: "구약에서 5316번 사용됨. 가장 빈번한 말하기 동사.",
    e: "기본 어근"
  },
  "H776": {
    m: "땅, 나라",
    d: "땅, 흙; 나라, 지역; 지상 세계.",
    u: "구약에서 2504번 사용됨. 하나님이 창조하신 땅.",
    e: "기본 어근"
  },
  "H982": {
    m: "신뢰하다, 확신하다",
    d: "신뢰하다, 확신을 갖다; 안전하다.",
    u: "구약에서 120번 사용됨. 여호와를 신뢰함.",
    e: "기본 어근"
  },
  "H1004": {
    m: "집, 거처",
    d: "집, 거주지; 가족, 가정; 성전.",
    u: "구약에서 2055번 사용됨. 여호와의 집.",
    e: "בָּנָה(banah)에서 유래 = 짓다"
  },
  "H1254": {
    m: "창조하다",
    d: "무에서 창조하다; 형성하다, 만들다; 하나님의 독점적 활동.",
    u: "구약에서 54번 사용됨. 하나님이 하늘과 땅을 창조하셨다.",
    e: "기본 어근"
  },
  "H1516": {
    m: "골짜기, 계곡",
    d: "골짜기, 협곡, 계곡; 평야.",
    u: "구약에서 60번 사용됨. 사망의 음침한 골짜기.",
    e: "기본 어근"
  },
  "H1878": {
    m: "살찌우다, 기름지게 하다",
    d: "기름지게 하다, 살찌우다; 번영하다.",
    u: "구약에서 11번 사용됨. 주께서 내 머리에 기름을 부으시니.",
    e: "דֶּשֶׁן(deshen) = 기름, 재"
  },
  "H1980": {
    m: "걷다, 가다",
    d: "걷다, 가다, 오다; 살다, 행동하다.",
    u: "구약에서 1554번 사용됨. 매우 빈번한 이동 동사.",
    e: "기본 어근"
  },
  "H2617": {
    m: "선하심, 자비, 신실함",
    d: "선하심, 자비; 언약에 대한 신실함; 충성스러운 사랑.",
    u: "구약에서 248번 사용됨. 여호와의 선하심.",
    e: "חָסַד(chasad)에서 유래 = 선하다, 자비롭다"
  },
  "H2637": {
    m: "부족하다, 필요하다",
    d: "~이 없다, 필요하다; 줄어들다, 결핍되다.",
    u: "구약에서 23번 사용됨. 내게 부족함이 없으리로다(시편 23:1).",
    e: "기본 어근"
  },
  "H2896": {
    m: "좋은, 선한",
    d: "좋은, 기쁜, 훌륭한; 인자한, 의로운.",
    u: "구약에서 559번 사용됨. 하나님이 보시기에 좋았더라.",
    e: "기본 어근"
  },
  "H3068": {
    m: "여호와, 야훼",
    d: "하나님의 고유명사, 신성한 사자명 YHWH.",
    u: "구약에서 6828번 사용됨. 가장 거룩한 이름.",
    e: "הָיָה(hayah)에서 유래 = 있다, 존재하다"
  },
  "H3117": {
    m: "날, 낮",
    d: "낮(밤의 반대); 24시간; 시대, 때.",
    u: "구약에서 2301번 사용됨. 여호와께서 만드신 날.",
    e: "יוֹם(yowm) = 뜨거운"
  },
  "H3372": {
    m: "두려워하다, 무서워하다, 경외하다",
    d: "두려워하다, 무서워하다; 하나님을 경외하다, 존경하다.",
    u: "구약에서 335번 사용됨. 나는 화를 두려워하지 않음.",
    e: "기본 어근"
  },
  "H3563": {
    m: "잔, 컵",
    d: "잔, 컵; 몫, 운명.",
    u: "구약에서 31번 사용됨. 내 잔이 넘치나이다.",
    e: "기본 어근"
  },
  "H3820": {
    m: "마음, 정신",
    d: "마음, 감정의 자리; 정신, 지성, 의지.",
    u: "구약에서 598번 사용됨. 사람의 마음.",
    e: "기본 어근"
  },
  "H3915": {
    m: "밤",
    d: "밤(낮의 반대); 어둠의 시간.",
    u: "구약에서 234번 사용됨. 하나님이 낮과 밤을 나누셨다.",
    e: "기본 어근"
  },
  "H3966": {
    m: "매우, 극히",
    d: "매우, 극히, 많이; 힘차게, 빠르게.",
    u: "구약에서 300번 사용됨. 심히 좋았더라.",
    e: "מָאַד(ma'ad)에서 유래 = 많다"
  },
  "H4325": {
    m: "물, 물들",
    d: "물, 물들; 비; 흐름, 바다.",
    u: "구약에서 585번 사용됨. 창조의 물들.",
    e: "מַיִם(mayim) = 물의 쌍수형"
  },
  "H4999": {
    m: "목장, 거처",
    d: "목장 장소, 목초지; 거주지, 거처.",
    u: "구약에서 13번 사용됨. 푸른 목장에.",
    e: "נָאָה(na'ah)에서 유래 = 아름답다, 적합하다"
  },
  "H5148": {
    m: "인도하다, 이끌다",
    d: "인도하다, 이끌다, 지시하다; 안전하게 이끌다.",
    u: "구약에서 40번 사용됨. 그가 나를 인도하시니(시편 23:3).",
    e: "기본 어근"
  },
  "H5216": {
    m: "목장, 경작된 땅",
    d: "목초지, 목장; 경작된 땅, 들판.",
    u: "구약에서 2번 사용됨. 푸른 초장.",
    e: "נִיר(niyr) = 갈다"
  },
  "H5315": {
    m: "영혼, 생명, 사람",
    d: "영혼, 생명, 생명체; 사람, 자신; 욕망, 욕구.",
    u: "구약에서 753번 사용됨. 내 영혼, 내 생명.",
    e: "נָפַשׁ(naphash)에서 유래 = 숨쉬다"
  },
  "H5769": {
    m: "영원, 영원히",
    d: "무한한 시간, 영원; 영원히, 영속성.",
    u: "구약에서 439번 사용됨. 하나님의 영원한 사랑.",
    e: "עָלַם(alam)에서 유래 = 숨기다, 숨겨지다"
  },
  "H6186": {
    m: "배열하다, 배치하다",
    d: "순서대로 배열하다, 배치하다; 상을 차리다.",
    u: "구약에서 75번 사용됨. 주께서 상을 차리시니(시편 23:5).",
    e: "기본 어근"
  },
  "H6213": {
    m: "만들다, 이루다",
    d: "만들다, 제작하다, 이루다; 행동하다, 일하다.",
    u: "구약에서 2632번 사용됨. 매우 빈번한 동사.",
    e: "기본 어근"
  },
  "H6664": {
    m: "의, 정의",
    d: "의, 정의, 공정; 신실함.",
    u: "구약에서 119번 사용됨. 의의 길.",
    e: "צָדַק(tsadaq)에서 유래 = 의롭다"
  },
  "H6754": {
    m: "형상, 모양",
    d: "형상, 모양; 형태, 외양.",
    u: "구약에서 17번 사용됨. 하나님의 형상대로 지음 받은 사람.",
    e: "צָלַל(tsalal)에서 유래 = 그림자지다, 닮다"
  },
  "H6757": {
    m: "사망의 그늘, 깊은 어둠",
    d: "깊은 어둠, 죽음 같은 어둠; 사망의 그늘.",
    u: "구약에서 18번 사용됨. 극심한 위험을 상징함.",
    e: "צֵל(tsel) = 그늘 + מָוֶת(maveth) = 죽음"
  },
  "H6887": {
    m: "곤경에 빠지다, 대적자",
    d: "압박받다, 곤경에 빠지다; 대적자, 원수.",
    u: "구약에서 58번 사용됨. 내 대적들이 보는 앞에서.",
    e: "기본 어근"
  },
  "H7121": {
    m: "부르다, 외치다, 선포하다",
    d: "부르다, 외치다; 이름 짓다; 선포하다, 소집하다.",
    u: "구약에서 736번 사용됨. 여호와의 이름을 부르다.",
    e: "기본 어근"
  },
  "H7200": {
    m: "보다, 바라보다",
    d: "눈으로 보다; 인식하다, 이해하다; 예비하다.",
    u: "구약에서 1311번 사용됨. 하나님이 보시기에 좋았더라.",
    e: "기본 어근"
  },
  "H7225": {
    m: "시작, 처음 열매",
    d: "시작, 시초; 가장 좋은 것, 처음 열매.",
    u: "구약에서 51번 사용됨. '태초에 하나님이 창조하시니라...'",
    e: "רֹאשׁ(rosh) = 머리, 시작"
  },
  "H7257": {
    m: "눕다, 쉬다",
    d: "눕다, 쉬다; 거하다; 품다.",
    u: "구약에서 30번 사용됨. 나를 눕게 하시니(시편 23:2).",
    e: "기본 어근"
  },
  "H7291": {
    m: "쫓다, 추격하다",
    d: "쫓다, 추격하다; 박해하다; 바짝 따르다.",
    u: "구약에서 144번 사용됨. 선하심이 나를 따르리니.",
    e: "기본 어근"
  },
  "H7307": {
    m: "영, 숨결, 바람",
    d: "숨결, 바람; 하나님이나 사람의 영; 정신적 성향.",
    u: "구약에서 378번 사용됨. 하나님의 영.",
    e: "רוּחַ(ruach) = 불다"
  },
  "H7462": {
    m: "먹이다, 목자, 양육하다",
    d: "양떼를 먹이다; 목자가 되다; 먹이다, 돌보다.",
    u: "구약에서 173번 사용됨. 여호와는 나의 목자시라.",
    e: "기본 어근"
  },
  "H7549": {
    m: "궁창, 창공",
    d: "궁창, 하늘의 둥근 천장, 창공; 하늘.",
    u: "구약에서 17번 사용됨. 물 가운데의 궁창.",
    e: "רָקַע(raqa)에서 유래 = 펴다, 두드리다"
  },
  "H7626": {
    m: "지팡이, 지파",
    d: "지팡이, 막대기; 지파, 가계 분파.",
    u: "구약에서 190번 사용됨. 주의 지팡이와 막대기.",
    e: "שָׁבַט(shabat)에서 유래 = 가지치다"
  },
  "H7725": {
    m: "돌아가다, 돌이키다, 회복하다",
    d: "돌아가다, 돌아오다; 회복하다, 새롭게 하다; 회개하다.",
    u: "구약에서 1058번 사용됨. 내 영혼을 소생시키시니.",
    e: "기본 어근"
  },
  "H7979": {
    m: "상",
    d: "식사하는 상; 진설병 상.",
    u: "구약에서 71번 사용됨. 차려진 상.",
    e: "שָׁלַח(shalach)에서 유래 = 보내다, 펴다"
  },
  "H8064": {
    m: "하늘, 하늘들",
    d: "하늘, 창공; 하나님의 거처; 보이는 하늘.",
    u: "구약에서 420번 사용됨. 하늘과 땅.",
    e: "שָׁמַיִם(shamayim) = 높은 곳의 쌍수형"
  },
  "H8414": {
    m: "형체가 없는, 공허한, 혼돈",
    d: "황무지, 황폐; 혼돈, 공허, 무.",
    u: "구약에서 20번 사용됨. 땅이 혼돈하고 공허하였다.",
    e: "תָּהָה(tahah)에서 유래 = 배회하다"
  }
};

export default strongTranslationsKO;
